import { authHeader, handleResponse } from '../helpers'

export const workerService = {
    getWorkers,
    getWorker,
    createWorker,
    editWorker,
    deleteWorker
};

function getWorkers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/worker`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getWorker(workerId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/worker/${workerId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function createWorker(workerData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: workerData
    };
    return fetch(process.env.VUE_APP_API_URL + `/worker`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function editWorker(workerId, workerData) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: workerData
    };
    return fetch(process.env.VUE_APP_API_URL + `/worker/${workerId}`, requestOptions)
    .then(response => {
        return response;
    });
}

function deleteWorker(workerId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_API_URL + `/worker/${workerId}`, requestOptions)
    .then(response => response.text())
    .then(response => {
        return response;
    });
}
